import { CalculatorBase } from "./calculatorBase";


export class CalculatorFertility extends CalculatorBase {
    el: JQuery;
    fForm: JQuery;
    fLastCycleStart: JQuery;
    fPeriodLength: JQuery;
    fSubmit: JQuery;
    dError: JQuery;
    dResult: JQuery;

    constructor() {
        super("fertility");
        this.el = $("#calculator-fertility");
        if (this.el.length) {
            this.fForm = $("#fForm", this.el).on("submit", this.calculate.bind(this));
            this.fLastCycleStart = $("#fLastCycleStart", this.el).on("change", this.inputChange.bind(this));
            this.fPeriodLength = $("#fPeriodLength", this.el).on("change", this.inputChange.bind(this));
            this.fSubmit = $("#fSubmit", this.el);
            this.dError = $(".error", this.el);
            this.dResult = $(".result", this.el);
        }
    }

    inputChange(e: JQuery.ChangeEvent) {
        this.fLastCycleStart.parent().removeClass("has-error");
        this.dError.hide().html("");
        this.dResult.hide().html("");
    }

    calculate(e: JQuery.SubmitEvent) {
        super.calculate(e);

        this.dError.hide().html("");
        this.dResult.hide().html("");

        fetch(`${window.variables.calculatorFertilityCalculateUrl}?lastCycleStart=${this.fLastCycleStart.val()}&periodLength=${this.fPeriodLength.val()}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error("Network response was not OK");
                }
                return response.json();
            })
            .then((data: Adcsk.CalcFertilityResult) => {
                if (data.Error) {
                    this.dError.html(data.Msg).show();
                    if (data.LastCycleStartError) {
                        this.fLastCycleStart.parent().addClass("has-error");
                    }
                    return;
                }
                this.dResult.html(data.FormatedResult).show();
            })
            .catch(reason => {
                this.dError.text("Nastala neočakávaná chyba.").show();
            });

        return false;
    }
}
